import { use } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import { SUPPORTED_LANGUAGES } from './constants'
import resources from './locales'

declare module 'react-i18next' {
  type CustomTypeOptions = {
    defaultNS: 'en'
    resources: {
      en: typeof resources.en.translation
      ja: typeof resources.ja.translation
    }
  }
}

const i18n = use(LanguageDetector).use(initReactI18next)

// NOTE: awaitする必要無し。 https://www.i18next.com/overview/getting-started#basic-sample

i18n.init({
  resources,
  fallbackLng: SUPPORTED_LANGUAGES,
  supportedLngs: SUPPORTED_LANGUAGES,
  interpolation: {
    escapeValue: false,
    formatSeparator: ',',
  },
  react: {
    useSuspense: true,
  },
  detection: {
    lookupQuerystring: 'lang',
  },
})

export default i18n
